import { Component } from 'react';
import { FormattedDate, WrappedComponentProps, injectIntl } from 'react-intl';

import messages from './NextRepaymentText.messages';
import { TextWithIcon } from '../textWithIcon';
import styles from './NextRepaymentText.module.css';
import { TooltipExclamationMarkSVG } from '../../../../../svgComponents/tooltipExclamationMarkSVG/index';
import { CalendarTickSVG } from '../../../../../svgComponents/calendarTickSVG/index';
import { FormattedCurrency } from '../../../../../iwIntlProvider/FormattedCurrency';

type TProps = {
    isPaymentOverdue?: any;
    amount: number;
    date: string;
    locale: object;
    totalBalance: number;
};

class NextRepaymentText extends Component<TProps & WrappedComponentProps> {
    getMessageObject() {
        const { isPaymentOverdue } = this.props;

        if (isPaymentOverdue) {
            return messages.linesNextRepaymentOverdue;
        }
        return messages.linesNextRepayment;
    }

    getIcon() {
        const { isPaymentOverdue } = this.props;

        if (isPaymentOverdue) {
            return <TooltipExclamationMarkSVG className={styles.overdueText} />;
        }
        return <CalendarTickSVG />;
    }

    getCustomStyles() {
        const { isPaymentOverdue } = this.props;

        if (isPaymentOverdue) {
            return styles.overdueText;
        }
        return null;
    }

    render() {
        const {
            amount,
            date,
            intl: { formatMessage }
        } = this.props;
        const messageObject = this.getMessageObject();
        const icon = this.getIcon();
        const customStyles = this.getCustomStyles();

        return (
            <TextWithIcon
                className={customStyles}
                icon={icon}
                messageObject={messageObject}
                values={{
                    amount: <FormattedCurrency value={amount} />,
                    date: (
                        <FormattedDate
                            day="numeric"
                            month="long"
                            year="numeric"
                            value={new Date(date)}
                        />
                    ),
                    unableToPayLink: (
                        <a
                            href={formatMessage(messages.unableToPayLink)}
                            rel="noopener noreferrer"
                            className={styles.link}
                            target="_blank"
                        >
                            {formatMessage(messages.unableToPayLinkText)}
                        </a>
                    )
                }}
            />
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default injectIntl(NextRepaymentText);
